import {
  createStyles,
  Grid,
  makeStyles,
  Theme,
  Typography,
} from '@material-ui/core'
import { useCallback, useEffect, useMemo, useState } from 'react'
import { PageFilter } from '../../../shared/src/data/pageFilter'
import { ViewType } from './viewType'
import { useSelectedFilesContext } from '../selectedFilesProvider'
import ViewTypePagesSelector from './ViewTypePageSelector'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    grid: {
      padding: theme.spacing(2),
    },
  }),
)

type PagesClassifierProps = {
  viewTypesPages: Map<ViewType, number[]>
  setIsStepValid: (isValid: boolean) => void
  setPageFilters: (pages: PageFilter[]) => void
}

export default function PagesSelector({
  viewTypesPages,
  setIsStepValid,
  setPageFilters,
}: PagesClassifierProps): JSX.Element {
  const classes = useStyles()
  const viewTypes = useMemo(
    () => [
      ViewType.floorPlan,
      ViewType.unitPlan,
      ViewType.plumbing,
      ViewType.mechanical,
      ViewType.lighting,
      ViewType.other,
    ],
    [],
  )

  const [viewTypeFilters, setViewTypeFilters] = useState<
    Map<ViewType, PageFilter>
  >(new Map())
  const { files, pageToFileMap } = useSelectedFilesContext()
  const pages = Array.from(pageToFileMap.keys())
  const minPage = Math.min(...pages)
  const maxPage = Math.max(...pages)

  useEffect(() => {
    setPageFilters(Array.from(viewTypeFilters.values()))
  }, [viewTypeFilters, setPageFilters])

  const setViewTypeFilter = useCallback(
    (viewType: ViewType, pageFilter: PageFilter) => {
      setViewTypeFilters((prevViewTypeFilters) => {
        const newViewTypeFilters = new Map(prevViewTypeFilters)
        newViewTypeFilters.set(viewType, pageFilter)
        return newViewTypeFilters
      })
    },
    [setViewTypeFilters],
  )

  return (
    <Grid className={classes.grid} container spacing={1}>
      <Grid item xs={4}>
        <Typography>
          {files.length === 1 ? files[0].name : 'Merged File'}
        </Typography>
      </Grid>
      {viewTypes.map((viewType, i) => (
        <Grid container spacing={2} alignItems='flex-end' key={i}>
          <ViewTypePagesSelector
            viewType={viewType}
            viewTypesPages={viewTypesPages.get(viewType)}
            maxPage={maxPage}
            minPage={minPage}
            setViewTypeFilters={setViewTypeFilter}
            setIsStepValid={setIsStepValid}
          />
        </Grid>
      ))}
    </Grid>
  )
}
